// Generated DKIM values are ASCII. Each DNS TXT character-string holds <=255 bytes.
export function dkimTxtParts(value:string):string[]{
 if(!/^[\x20-\x7e]+$/.test(value))throw new Error('Expected an ASCII DKIM value');
 return value.match(/.{1,255}/g)!;
}
export function quotedDkimTxt(value:string):string{
 return dkimTxtParts(value).map(part=>JSON.stringify(part)).join(' ');
}

// Keep the editable host separate from the zone appended by most DNS panels.
export function dnsHost(name:string,domain:string):{host:string;suffix:string}{
 const full=name.replace(/\.$/,''),zone=domain.replace(/\.$/,'');
 if(full.toLowerCase()===zone.toLowerCase())return {host:'@',suffix:` (${zone})`};
 if(full.toLowerCase().endsWith('.'+zone.toLowerCase()))return {host:full.slice(0,-zone.length-1),suffix:full.slice(-zone.length-1)};
 return {host:full,suffix:''};
}

// Read both the current combined value and the additive structured MX contract.
export function mxFields(record:{value:unknown;priority?:unknown}):{value:string;priority:number|null}{
 const value=String(record.value??''),match=/^(\d{1,5})\s+(.+)$/.exec(value);
 const candidate=record.priority??(match?Number(match[1]):null);
 const priority=typeof candidate==='number'&&Number.isInteger(candidate)&&candidate>=0&&candidate<=65535?candidate:null;
 return {value:match?match[2]!:value,priority};
}
